import { Strings } from './Strings';
const UNIX_SEPARATOR = '/';
const WINDOWS_SEPARATOR = '\\';
export class Files {

  public static getFileName(path: string): string {
    if (Strings.isBlank(path)) return path;

    const lastUnixPos = path.lastIndexOf(UNIX_SEPARATOR);
    const lastWindowsPos = path.lastIndexOf(WINDOWS_SEPARATOR);

    return path.substring(Math.max(lastUnixPos, lastWindowsPos) + 1);
  }

  public static formatBytes(bytes: number, decimals: number = 2, zeroResult: string = "0 B"): string {
    if (bytes == undefined) return '';

    if (bytes == 0) return zeroResult;

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    if (Object.is(i, NaN))
      return String(bytes);

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
  
}
